const Colors = {
  purple: '#8348ef',
  'purple-fill-80': '#7923EE',
  'purple-light': '#9a87db',
  navy: '#183d85',
  'blue-darkest': '#162D5B',
  'blue-darker-fill-80': '#143987',
  'blue-darker': '#0641BD',
  'blue-dark-fill-80': '#064FDA',
  'blue-dark': '#105DEC',
  blue: '#196CFF',
  'blue-shadow': '#4085FE',
  'blue-light': '#6AA0FE',
  'blue-light-fill-20': '#8CB5FE',
  'blue-lighter': '#ADCAFE',
  'blue-lightest': '#BED4FC',
  'green-darkest': '#323F35',
  'green-darker-fill-80': '#415546',
  'green-darker': '#4C6551',
  'green-dark-fill-80': '#577667',
  'green-dark': '#648881',
  green: '#719B9D',
  'green-light': '#9CC7C9',
  'green-lighter': '#D3ECEE',
  'green-lightest': '#E4F4F5',
  'orange-darkest': '#4D3721',
  'orange-darker-fill-80': '#684928',
  'orange-darker': '#7C552C',
  'orange-dark-fill-80': '#93632E',
  'orange-dark': '#AD7130',
  orange: '#CA822F',
  'orange-light': '#F9AE0F',
  'orange-lighter': '#FFE19F',
  'orange-lightest': '#FDEFC8',
  'rose-darkest': '#4C3731',
  'rose-darker-fill-80': '#916255',
  'rose-darker': '#7B544A',
  'rose-dark-fill-80': '#916255',
  'rose-dark': '#AB7060',
  rose: '#C6806C',
  'rose-light': '#F3AB96',
  'rose-lighter': '#F7DED7',
  'rose-lightest': '#F8EDEB',
  red: '#DE1214',
  black: '#323232',
  'black-fill-80': '#484848',
  'black-opacity-20': 'rgba(50, 50, 50, 0.2)',
  'gray-shadow': 'rgba(0, 0, 0, 0.1)',
  'gray-dark': '#7A7A7A',
  gray: '#8F8F8F',
  'gray-light': '#BEBEBE',
  'gray-lighter': '#e9e9e9',
  'gray-lightest': '#f7f7f7',
  'gray-lightest-opacity-50': 'rgba(243, 243, 243, 0.5)',
  white: '#ffffff',
  transparent: 'rgba(255, 255, 255, 0)',
};

export default Colors;
export type Color = keyof typeof Colors;
